export enum RefundSources {
  ORIGINAL_SOURCE = 0,
  WALLET_ONLY = 1
}

export enum PaymentRefundStates {
  REFUNDED_NO = 0,
  REFUNDED_YES = 1,
  REFUNDED_PARTLY = 2,
  REFUNDED_EXCEEDED = 3
}

export enum RefundOptions {
  NO_REFUND = 0,
  // Intentionally the same ID as FULL_REFUND
  INITIAL_PARTIAL_PAYMENT = 1,
  FULL_REFUND = 1,
  PARTIAL_REFUND = 2
}
